<template>
  <div>
    <v-radio-group v-model="order.payment" label="Betalingsmåte" class="mt-0">
      <v-radio
        v-if="isMethodEnabled('vipps')"
        name="payment"
        :label="getEnabledMethod('vipps').frontend_label"
        value="vipps"
      />
      <v-radio
        v-if="isMethodEnabled('stripe')"
        name="payment"
        :label="getEnabledMethod('stripe').frontend_label"
        value="stripe"
      />
      <stripe-element-card
        v-if="isMethodEnabled('stripe')"
        v-show="order.payment == 'stripe'"
        ref="stripe-element-card"
        :pk="getEnabledMethod('stripe').public_key"
        :hide-postal-code="true"
        :elements-options="elementsOptions"
        @token="stripeTokenCreated"
        @element-change="checkStripeValidation"
      />

      <v-radio
        v-if="isMethodEnabled('offline')"
        name="payment"
        :label="getEnabledMethod('offline').frontend_label"
        value="offline"
      />
      <v-alert
        v-if="isMethodEnabled('offline')"
        v-show="
          order.payment == 'offline' &&
          getEnabledMethod('offline').description != ''
        "
        dense
        outlined
        type="info"
        elevation="2"
        class="payment-method-description"
      >
        {{ getEnabledMethod("offline").description }}
      </v-alert>
    </v-radio-group>
  </div>
</template>

<script>
import { StripeElementCard } from "@vue-stripe/vue-stripe";

export default {
  name: "CheckoutPaymentMethods",

  components: {
    StripeElementCard,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    elementsOptions: {
      locale: "nb",
    },
    stripeCardValid: false,
  }),

  created() {
    // Check if there is only one available payment method,
    // if that is the case, lets select it
    if (this.vendor.enabled_payment_methods.length == 1) {
      this.order.payment = this.vendor.enabled_payment_methods[0].variant;
    }
  },

  methods: {
    checkStripeValidation(e) {
      this.stripeCardValid = e.complete;
    },
    getEnabledMethod(method) {
      if (typeof this.vendor.enabled_payment_methods === "undefined") {
        return false;
      }

      return this.vendor.enabled_payment_methods.find(
        (x) => x.variant == method
      );
    },
    isMethodEnabled(method) {
      return typeof this.getEnabledMethod(method) !== "undefined";
    },
    stripeTokenCreated(token) {
      this.$emit("update:stripeToken", token);
    },
  },
};
</script>

<style scoped>
.v-alert.payment-method-description {
  background-color: white !important;
}
</style>
